export var PlayerAdapterPlaybackState;
(function (PlayerAdapterPlaybackState) {
    PlayerAdapterPlaybackState["IDLE"] = "idle";
    PlayerAdapterPlaybackState["STOPPED"] = "stopped";
    PlayerAdapterPlaybackState["PLAYING"] = "playing";
    PlayerAdapterPlaybackState["PAUSED"] = "paused";
    PlayerAdapterPlaybackState["WAITING"] = "waiting";
})(PlayerAdapterPlaybackState || (PlayerAdapterPlaybackState = {}));
